import { HttpParameterCodec } from '@angular/common/http';
import { isBoolean } from 'lodash';

export class CustomHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  encodeValue(value: string | number | boolean): string {
    if (isBoolean(value)) {
      return value ? 'true' : 'false';
    }
    return encodeURIComponent(value ? value.toString().trim() : '');
  }
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
